/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import '@fontsource/roboto';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createTheme, Theme } from '@mui/material';
import * as colors from './colors/index';
import { qtmTypography } from './typography';



export const qtmLightTheme: Theme = createTheme({
  palette: {
    common: {
      black: colors.common.black,
      white: colors.common.white,
    },
    mode: 'light',
    primary: {
      light: colors.blue[300],
      main: colors.blue[700],
      dark: colors.blue[900],
    },
    secondary: {
      light: colors.gray[200],
      main: colors.gray[700],
      dark: colors.gray[900],
    },
    success: {
      light: colors.green[300],
      main: colors.green[700],
      dark: colors.green[900],
    },
    info: {
      light: colors.blue[300],
      main: colors.blue[700],
      dark: colors.blue[900],
    },
    warning: {
      light: colors.orange[200],
      main: colors.orange[700],
      dark: colors.orange[900],
    },
    error: {
      light: colors.red[200],
      main: colors.red[700],
      dark: colors.red[900],
    },
    background: {
      default: colors.pitrho.light.background.default,
      paper: colors.pitrho.light.background.paper,
      header: colors.pitrho.light.background.header
    },
  },
  typography: {
    ...qtmTypography,
  },
});